// ** Redux Imports
import { createAsyncThunk } from '@reduxjs/toolkit'
import { apiMethods } from '@services/methods'
import { baseURL } from '@services/common'
// ** Axios Imports
import axios from 'axios'
import {
  addUser,
  setUpdateModal,
  setUser,
  setVehicle,
  showUser,
  showVehicle
} from './slice'

import { BasicToastContent } from '@src/components/basic-toast-content'
import toast from 'react-hot-toast'

const endpoints = {
  autocomplete: `${baseURL}/admin/users/autocomplete`,
  createVehicle: `${baseURL}/admin/vehicles/with-tag`,
  addUser: `${baseURL}/admin/users/commerce/user-signup`,
  getUser: `${baseURL}/admin/users`,
  deleteVehicle: `${baseURL}/admin/vehicles/user-remove`,
  updateVehicle: `${baseURL}/admin/vehicles/edit`
}

export const deleteVehicleThuk = (vehicleId) => {
  return async (dispatch, getState) => {
    const userId = getState().usersList.selectedUser._id

    const body = {
      vehicle_id: vehicleId,
      customer_id: userId
    }

    const { ok, res } = await apiMethods.authPost({
      url: endpoints.deleteVehicle,
      body
    })

    if (ok) {
      const id = getState().usersList.selectedUser._id
      const { res: response } = await apiMethods.authGet({
        url: `${endpoints.getUser}/${id}`
      })

      dispatch(
        setUser({
          flag: true,
          data: res.data
        })
      )
      toast((t) => (
        <BasicToastContent
          t={t}
          message={'El vehículo se eliminó de forma exitosa'}
          type={'success'}
        />
      ))
    } else {
      toast((t) => (
        <BasicToastContent
          t={t}
          message={'No fue posible eliminar el vehículo'}
          type={'danger'}
        />
      ))
    }
  }
}

export const updateVehicleThuk = (body) => {
  return async (dispatch, getState) => {
    const { ok, res } = await apiMethods.authPost({
      url: endpoints.updateVehicle,
      body
    })

    if (ok) {
      const id = getState().usersList.selectedUser._id
      const { res: response } = await apiMethods.authGet({
        url: `${endpoints.getUser}/${id}`
      })

      dispatch(
        setUser({
          flag: true,
          data: res.data
        })
      )
      toast((t) => (
        <BasicToastContent
          t={t}
          message={'El vehículo se actualizó de forma exitosa'}
          type={'success'}
        />
      ))
    } else {
      toast((t) => (
        <BasicToastContent
          t={t}
          message={'No fue posible actualizar el vehículo'}
          type={'danger'}
        />
      ))
    }
  }
}

export const addUserThunk = (show) => {
  return async (dispatch) => {
    dispatch(addUser(show))
  }
}

export const showUserListThunk = (show) => {
  return async (dispatch) => {
    dispatch(showUser(show))
  }
}

export const showVehicleListThunk = (show) => {
  return async (dispatch) => {
    dispatch(showVehicle(show))
  }
}

export const setUserThunk = (body, flag) => {
  return async (dispatch) => {
    dispatch(
      setUser({
        data: body,
        flag
      })
    )
  }
}

export const addUserRequest = createAsyncThunk(
  'appUsers/addUserRequest',
  async (body) => {
    const { ok, res } = await apiMethods.authPost({
      url: endpoints.addUser,
      body
    })

    if (!ok) {
      toast((t) => <BasicToastContent t={t} message={res} type={'danger'} />)
      return {
        data: null,
        list: [],
        flag: false
      }
    }

    toast((t) => (
      <BasicToastContent t={t} message={'Registro exitoso'} type={'success'} />
    ))

    return {
      data: res.data,
      list: [res.data],
      flag: true
    }
  }
)

export const getAllData = createAsyncThunk(
  'appUsers/getAllData',

  async (body) => {
    const { res } = await apiMethods.authPost({
      url: endpoints.autocomplete,
      body
    })

    return res.data.items
  }
)

export const getData = createAsyncThunk('appUsers/getData', async (params) => {
  const response = await axios.get('/api/users/list/data', params)

  return {
    params,
    data: response.data.users,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async (id) => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.user
})

export const selectUser = createAsyncThunk(
  'appUsers/selectUser',
  async (user) => {
    const { res } = await apiMethods.authGet({
      url: `${endpoints.getUser}/${user._id}`
    })
    return res.data
  }
)

export const addVehicle = createAsyncThunk(
  'appUsers/addVehicle',
  async (formValues, { dispatch, getState }) => {
    const { ok, res } = await apiMethods.authPost({
      url: endpoints.createVehicle,
      body: formValues
    })

    if (!ok) {
      toast((t) => <BasicToastContent t={t} message={res} type={'danger'} />)
      return {
        flag: true,
        data: getState().usersList.selectedUser
      }
    }

    const id = getState().usersList.selectedUser._id
    const { res: response } = await apiMethods.authGet({
      url: `${endpoints.getUser}/${id}`
    })

    toast((t) => (
      <BasicToastContent t={t} message={'Registro exitoso'} type={'success'} />
    ))

    return {
      flag: false,
      data: response.data
    }
  }
)

export const deleteUser = createAsyncThunk(
  'appUsers/deleteUser',
  async (id, { dispatch, getState }) => {
    await axios.delete('/apps/users/delete', { id })
    await dispatch(getData(getState().users.params))
    // await dispatch(builder.getAllData())
    return id
  }
)

export const usersAutocomplete = createAsyncThunk(
  'appUsers/usersAutocomplete',
  async (body) => {
    const { ok, res } = await apiMethods.authPost({
      url: endpoints.autocomplete,
      body
    })
    if (!ok) {
      return []
    }

    return res.data.items
  }
)

export const setModal = (action) => {
  return async (dispatch) => {
    dispatch(setUpdateModal(action))
  }
}

export const setVehicleThunk = (body) => {
  return async (dispatch) => {
    dispatch(setVehicle(body))
  }
}
